import React from 'react';
import { Phone, MapPin, Instagram, Facebook } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

export const Contact = () => {
  const { language } = useLanguage();
  const t = translations[language];
  
  const phones = ["+964 750 208 9427", "+964 750 033 4545"];
  const location = "Iraq / Zakho";

  return (
    <section id="contact" className="py-20 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-6">
            {t.contactTitle}
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t.contactDescription}
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Phone Card */}
          <Card className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-orange-50">
            <CardContent className="p-8 text-center">
              <div className="flex justify-center mb-6">
                <div className="p-4 bg-orange-100 rounded-full shadow-sm">
                  <Phone className="w-8 h-8 text-orange-600" strokeWidth={1.5} />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{t.callUs}</h3>
              {phones.map((phone, index) => (
                <a
                  key={index}
                  href={`tel:${phone}`}
                  className="block text-gray-600 hover:text-orange-600 transition-colors mb-2 text-lg font-medium"
                  dir="ltr"
                >
                  {phone}
                </a>
              ))}
            </CardContent>
          </Card>

          {/* Location Card */}
          <Card className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-orange-50">
            <CardContent className="p-8 text-center">
              <div className="flex justify-center mb-6">
                <div className="p-4 bg-orange-100 rounded-full shadow-sm">
                  <MapPin className="w-8 h-8 text-orange-600" strokeWidth={1.5} />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{t.location}</h3>
              <a
                href="https://maps.google.com/maps?q=37.14051818847656%2C42.64603042602539&z=17&hl=en"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-orange-600 transition-colors text-lg font-medium inline-flex items-center gap-2"
              >
                <MapPin className="w-5 h-5" />
                {location}
              </a>
            </CardContent>
          </Card>

          {/* Social Media Card */}
          <Card className="border-none shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-orange-50">
            <CardContent className="p-8 text-center">
              <div className="flex justify-center mb-6">
                <div className="p-4 bg-orange-100 rounded-full shadow-sm">
                  <Instagram className="w-8 h-8 text-orange-600" strokeWidth={1.5} />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{t.socialMedia}</h3>
              <div className="space-y-3">
                <a
                  href="https://www.instagram.com/alhanadiscompany?igsh=MTNydHc4eTJ4bmx6aw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-orange-600 transition-colors text-lg font-medium inline-flex items-center gap-2"
                >
                  <Instagram className="w-5 h-5" />
                  {t.followUs}
                </a>
                <br />
                <a
                  href="https://www.facebook.com/share/17rs8muTq3/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-600 hover:text-orange-600 transition-colors text-lg font-medium inline-flex items-center gap-2"
                >
                  <Facebook className="w-5 h-5" />
                  {t.followUsFacebook}
                </a>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-orange-500 rounded-lg p-12 shadow-xl max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-white mb-4">
              {t.readyToOrder}
            </h3>
            <p className="text-white/90 text-lg mb-6 leading-relaxed">
              {t.orderDescription}
            </p>
            <a
              href={`tel:${phones[0]}`}
              className="inline-flex items-center px-8 py-4 text-lg font-medium text-orange-600 bg-white hover:bg-gray-100 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
            >
              {t.callNow}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
